export const CHART_SOLD_YEARS = [
  '3 months',
  '6 months',
  '1 year',
  '2 years',
  '3 years',
  '5 years',
  '10 years',
];

export const INTERIOR_BC_CITIES = [
  'Castlegar',
  'Cranbrook',
  'Fernie',
  'Kamloops',
  'Kelowna',
  'Kimberley',
  'Vernon',
  'Oliver',
  'Osoyoos',
  'Prince George',
  'Quesnel',
  'Revelstoke',
  'Summerland',
  'Peachland',
  'Penticton',
  'Sicamous',
  'Salmon Arm',
  'Nelson',
  'Trail',
  'Merritt',
  'Williams Lake',
];

export const COMPARABLES_STYLE_ITEMS = [
  { text: '1 + Half Storey', value: '1 + Half Storey' },
  { text: '2 Storey', value: '2 Storey' },
  { text: '2 Storey Split', value: '2 Storey Split' },
  { text: '2 + Half Storey', value: '2 + Half Storey' },
  { text: '3 Level Split', value: '3 Level Split' },
  { text: '3 Storey', value: '3 Storey' },
  { text: '4 Level Split', value: '4 Level Split' },
  { text: '5 Level Split', value: '5 Level Split' },
  { text: 'Bi-Level', value: 'Bi-Level' },
  { text: 'Bungalow', value: 'Bungalow' },
  { text: 'Loft', value: 'Loft' },
  { text: 'Single Level Unit', value: 'Single Level Unit' },
  { text: 'Multi Level Unit', value: 'Multi Level Unit' },
  { text: 'Stacked Townhouse', value: 'Stacked Townhouse' },
];
